<template>
  <div class="enterprise-info">
    <el-form
      class="apiForm"
      ref="formRef"
      label-position="top"
      :model="info"
      :rules="rules"
    >
      <el-form-item label="姓名" required prop="name">
        <el-input v-model="info.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" required prop="id_card_no">
        <el-input
          v-model="info.id_card_no"
          placeholder="请输入证件号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" required prop="phone">
        <el-input v-model="info.phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <!-- <el-form-item label="证件附件">
        <div class="flex">
          <div class="upload mr-[12px]">
            <file-pond
              ref="refUploadFont"
              v-if="ifRenderFilePondFont"
              label-idle="上传"
              v-bind:allow-multiple="false"
              :acceptedFileTypes="acceptedFileTypes.join(',')"
              @addfile="handleAddFontFile"
            >
            </file-pond>
            <div class="upload-main" ref="refUploadContentFont">
              <img
                v-if="!info.id_card_img_f"
                class="no-upload-img"
                src="@/assets/img/auth/id-font.png"
                alt=""
              />
              <div class="w-[100%] h-[100%] box-border px-[20px]" v-else>
                <img
                  class="w-[100%] h-[100%]"
                  :src="getObjectStorageFullUrl(info.id_card_img_f)"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="upload">
            <file-pond
              ref="refUploadBack"
              v-if="ifRenderFilePondBack"
              label-idle="上传"
              v-bind:allow-multiple="false"
              :acceptedFileTypes="acceptedFileTypes.join(',')"
              @addfile="handleAddBackFile"
            >
            </file-pond>
            <div class="upload-main" ref="refUploadContentBack">
              <img
                v-if="!info.id_card_img_b"
                class="no-upload-img"
                src="@/assets/img/auth/id-back.png"
                alt=""
              />
              <div class="w-[100%] h-[100%] box-border px-[20px]" v-else>
                <img
                  class="w-[100%] h-[100%]"
                  :src="getObjectStorageFullUrl(info.id_card_img_b)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="showIdCardError" class="el-form-item__error">
          请上传身份证正反两面照片
        </div>
      </el-form-item> -->
    </el-form>
    <div class="flex mt-[16px]">
      <div
        class="pointer flex-center w-[130px] h-[40px] text-[14px] font-[500] text-[#000] rounded-[40px] bg-[transparent] border border-solid border-black mr-[12px]"
        @click="handleCancel"
      >
        取消
      </div>
      <!-- <div
        class="pointer flex-center w-[130px] h-[40px] text-[14px] font-[500] text-[#fff] rounded-[40px] bg-[#000] relative"
        @click="confirmCertifyPerson"
        :disabled="isLoading"
      >
        <span :class="{ 'opacity-0': isLoading }">提交认证</span>
        <div v-if="isLoading" class="absolute inset-0 flex-center">
          <div class="loading-spinner"></div>
        </div>
      </div> -->
      <div
        class="relative w-[130px] h-[40px] flex justify-center items-center bg-black text-white rounded-full text-sm font-medium disabled:opacity-80"
        :class="{'pointer': !isLoading}"
        @click="confirmCertifyPerson"
      >
        <span :class="isLoading ? 'opacity-0' : 'opacity-100'">提交认证</span>
        <div
          v-if="isLoading"
          class="absolute w-5 h-5 border-2  border-t-white rounded-full border-solid animate-[spin_3s_linear_infinite]"
        ></div>
      </div>
    </div>
    <div v-if="errorText.length" class="mt-[6px] text-[red] text-[12px]">
      <div class="" v-for="item in errorText" :key="item">{{ item }}</div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, computed, defineEmits, onMounted } from "vue";
import vueFilePond from "vue-filepond";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import message from "@/components/functionCallComponent/message.jsx";
import { certifyInfo } from "@/api/api/apiKey.js";
import useUserDataStore from "@/store/userDataStore";

const emits = defineEmits(["cancelSubmit"]);
const userDataStore = useUserDataStore();
const acceptedFileTypes = [
  "image/*",
  "image/jpeg",
  "image/png",
  "image/webp", // 添加你最需要支持的格式
];
const ERROR_MAPPING = {
  7001: "个人信息校验不一致",
  7002: "个人实名认证审核失败",
  7003: "企业认证审核失败",
  7006: "企业名称不一致",
  7007: "营业执照号不一致",
  7008: "企业经营状态异常",
  7009: "该用户实名认证已完成，不支持重复认证",
};
const FilePond = vueFilePond();
const formRef = ref(null);
const refUploadFont = ref(null);
const refUploadBack = ref(null);
const refUploadContentFont = ref(null);
const refUploadContentBack = ref(null);
const ifRenderFilePondFont = ref(true);
const ifRenderFilePondBack = ref(true);
const info = reactive({
  t: 2,
  name: "",
  id_card_no: "",
  phone: "",
  // id_card_img_f: "",
  // id_card_img_b: "",
});
const errorText = ref([]);
const rules = reactive({
  name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
  id_card_no: [
    { required: true, message: "请输入证件号码", trigger: "blur" },
    {
      pattern: /^\d{17}[\dXx]$/,
      message: "请输入正确的身份证号码",
      trigger: "blur",
    },
  ],
  phone: [
    { required: true, message: "请输入手机号码", trigger: "blur" },
    {
      pattern: /^\d{11}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
});
const isLoading = ref(false);

// 初始化上传内容
const initUploadContent = () => {
  if (refUploadContentFont.value) {
    nextTick(() => {
      refUploadFont.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContentFont.value);
    });
    setTimeout(() => {
      refUploadFont.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", acceptedFileTypes.join(","));
    }, 20);
  }
  if (refUploadContentBack.value) {
    nextTick(() => {
      refUploadBack.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContentBack.value);
    });
    setTimeout(() => {
      refUploadBack.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", acceptedFileTypes.join(","));
    }, 20);
  }
};

const handleAddFontFile = async (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  handleAfterFontRead(fileItem.file);
};

const handleAfterFontRead = async (file) => {
  if (file.size > 1024 * 1024 * 100) {
    message.info({
      position: "top",
      content: "文件不可超过100Mb",
    });
    return;
  }
  nextTick(() => {
    ifRenderFilePondFont.value = true;
    nextTick(() => {
      initUploadContent();
    });
  });
  const { pathKey } = await objectStorage.uploadFileToObjectStorage(file);
  info.id_card_img_f = pathKey;
};

const handleAddBackFile = async (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  handleAfterBackRead(fileItem.file);
};

const handleAfterBackRead = async (file) => {
  if (file.size > 1024 * 1024 * 100) {
    message.info({
      position: "top",
      content: "文件不可超过100Mb",
    });
    return;
  }
  nextTick(() => {
    ifRenderFilePondBack.value = true;
    nextTick(() => {
      initUploadContent();
    });
  });
  const { pathKey } = await objectStorage.uploadFileToObjectStorage(file);
  info.id_card_img_b = pathKey;
};

const confirmCertifyPerson = () => {
  if (isLoading.value) return;
  formRef.value.validate((valid, fields) => {
    if (valid) {
      isLoading.value = true;
      certifyInfo(info)
        .then((res) => {
          if (res.code === 200) {
            if (res.data?.err_code) {
              errorText.value = res.data.err_code
                .map((code) => ERROR_MAPPING[code]) // 获取每个错误码对应的文案
                .filter(Boolean); // 过滤掉 undefined（避免无效错误码）
            } else {
              errorText.value = [];
              ElMessage.success("认证成功");
              userDataStore.getUserCertificationState();
              emits("cancelSubmit");
            }
          }
        })
        .catch((err) => {
          // 网络错误或其他异常，可以统一处理（可选）
          console.error("请求失败:", err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    } else {
      console.log("表单校验失败", fields);
    }
  });
};

const handleCancel = () => {
  emits("cancelSubmit");
};

onMounted(() => {
  nextTick(() => {
    initUploadContent();
  });
});
</script>
  
  <style lang="scss">
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.enterprise-info {
  input {
    color: #000;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
  }
  input::placeholder {
    color: rgba(0, 0, 0, 0.2) !important;
  }
  .el-input__wrapper {
    background: transparent;
    box-shadow: none !important;
    // border:  1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
    .is-focus {
      box-shadow: 1px #000 !important;
    }
  }
  .el-form-item__label {
    color: #000;
  }
  .el-input__inner {
    border-radius: 6px;
    padding: 0 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    height: 44px;
  }
  .el-input__inner:focus {
    border: 1px solid #000;
    // border: 1px solid #000;
  }
  .upload {
    width: 140px;
    --filepond-border-radius: 8px;
    --filepond-min-height: 80px;
    --filepond-min-height: 80px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    line-height: 0;
    .filepond--root {
      height: max-content !important;
      min-height: var(--filepond-min-height) !important;
      background: transparent;
      box-shadow: none;
      align-items: center;
      justify-content: center;
      border-radius: var(--filepond-border-radius);
      margin: 0;
      contain: unset !important;
      .filepond--wrapper {
        // height: max-content !important;
        border-radius: var(--filepond-border-radius);
      }
      .filepond--browser.filepond--browser {
        height: 0;
      }
      .filepond--list-scroller {
        display: none;
      }
      .filepond--credits {
        display: none;
      }

      .filepond--panel-root {
        border-radius: 0.5em;
        background: transparent;
        box-shadow: none;
        border-radius: max-content;
        display: none;
      }

      .filepond--assistant {
        display: none;
      }
      .filepond--drop-label {
        display: block;
        position: unset !important;
        visibility: visible !important;
        transform: translate3d(0px, 0, 0px) !important;
        height: max-content !important;
        border-radius: var(--filepond-border-radius) !important;
        min-height: var(--filepond-min-height) !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        & > label {
          width: 0;
          height: 0;
          overflow: hidden;
          padding: 0;
          display: block;
        }
      }
      fieldset {
        display: none;
      }
    }
    .upload-main {
      height: 80px;
      .no-upload-img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>